export default __webpack_public_path__ + "static/media/freelancer.08f14562.png";